export default {"src":"/_next/static/media/federal-bank.48e86748.svg","height":24,"width":78,"blurWidth":0,"blurHeight":0};